import { render, staticRenderFns } from "./mallOrderDetail.vue?vue&type=template&id=785d8e7e&scoped=true&"
import script from "./mallOrderDetail.vue?vue&type=script&lang=js&"
export * from "./mallOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./mallOrderDetail.vue?vue&type=style&index=0&id=785d8e7e&prod&lang=less&scoped=true&"
import style1 from "./mallOrderDetail.vue?vue&type=style&index=1&id=785d8e7e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d8e7e",
  null
  
)

export default component.exports